<div class="row" *ngIf="template == 'required'">
  <div class="col-12 color-blue text-xs">{{txtRequired}}</div>
</div>

<div class="row flex justify-center" *ngIf="template == 'isEmpty'">
  <div class="col-12 w-11/12 my-3 p-3 border rounded-lg text-center text-base text-gray-500 italic">{{messageNoFoundRegistry}}</div>
</div>